import React, { useState } from 'react';
import TestimonialModal from './TestimonialModal'; 

const ShareStorySection = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <section className="py-20 bg-slate-50"> 
            <div className="max-w-4xl mx-auto px-4">
                <div className="bg-white p-10 rounded-3xl shadow-lg border border-slate-200 text-center relative overflow-hidden">
                    {/* Background Glow Effect */}
                    <div className="absolute top-0 right-0 w-32 h-32 bg-orange-500/10 rounded-full blur-3xl -z-10"></div>
                    
                    <h3 className="text-2xl font-bold text-brand-dark mb-2">Have a Success Story to Share?</h3>
                    <p className="text-slate-500 mb-6 max-w-2xl mx-auto">
                        We'd love to hear about your experience with Acadfinity. Your story inspires others!
                    </p>
                    
                    <button 
                        onClick={() => setIsModalOpen(true)} 
                        className="bg-[#0f172a] text-white py-3 px-8 rounded-full font-bold uppercase tracking-widest text-xs hover:bg-orange-500 transition-all transform hover:-translate-y-1 shadow-xl"
                    >
                        Share Your Story
                    </button>
                </div>
            </div>

            {/* Modal Logic */}
            <TestimonialModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </section>
    );
};

export default ShareStorySection;